import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { History, Loader2 } from "lucide-react";

const KIND_LABELS = {
  sav_client_reminder: "Rappel SAV (veille)",
  sav_client_on_the_way: "Technicien en route",
  order_planned_client: "Chantier planifié",
};

// Statut affiché : livraison réelle Twilio si connue, sinon résultat de l'envoi
const STATUS = {
  delivered: ["Reçu", "border-emerald-300 bg-emerald-50 text-emerald-800"],
  undelivered: ["Échec de livraison", "border-red-300 bg-red-50 text-red-700"],
  failed: ["Échec", "border-red-300 bg-red-50 text-red-700"],
  queued: ["Envoyé", "border-blue-300 bg-blue-50 text-blue-800"],
  sending: ["Envoyé", "border-blue-300 bg-blue-50 text-blue-800"],
  sent: ["Envoyé", "border-blue-300 bg-blue-50 text-blue-800"],
  not_configured: ["Non envoyé (Twilio absent)", "border-slate-300 bg-slate-50 text-slate-600"],
  invalid_number: ["Non envoyé (numéro manquant)", "border-amber-300 bg-amber-50 text-amber-800"],
  opted_out: ["Non envoyé (désactivé)", "border-slate-300 bg-slate-50 text-slate-600"],
};

const statusOf = (log) => STATUS[log.delivery_status || log.status] || [log.delivery_status || log.status, ""];

export const ClientSmsHistory = ({ clientKey, clientName }) => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.getClientSmsHistory(clientKey, clientName).then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, [clientKey, clientName]);

  return (
    <div className="md:col-span-2 mt-2 pt-2 border-t" data-testid="client-sms-history">
      <p className="text-xs font-semibold text-muted-foreground mb-1.5 flex items-center gap-1">
        <History className="h-3.5 w-3.5" /> Historique des SMS
      </p>
      {items === null ? (
        <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
      ) : items.length === 0 ? (
        <p className="text-xs text-muted-foreground" data-testid="client-sms-history-empty">Aucun SMS pour ce client.</p>
      ) : (
        <div className="max-h-56 overflow-y-auto space-y-1.5 pr-1">
          {items.map((l) => {
            const [label, cls] = statusOf(l);
            return (
              <div key={l.id || l.created_at} className="rounded border p-2 text-xs" data-testid={`client-sms-log-${l.id}`}>
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <span className="font-medium">{KIND_LABELS[l.kind] || l.kind}</span>
                  <span className="text-muted-foreground">
                    {new Date(l.created_at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })}
                    {l.to ? ` · ${l.to}` : ""}
                  </span>
                  <Badge variant="outline" className={cls} data-testid={`client-sms-status-${l.id}`}>{label}</Badge>
                </div>
                <p className="mt-1 text-muted-foreground whitespace-pre-wrap">{l.body}</p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
